import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react'
import logo from "../../images/logo.png";
import { MainContainer, MainContent } from '../DataEntry/StyledFields';

const ThankYouForApplying = (props) => {

    useEffect(() => {
        console.log("ThankYouForApplying component")
    }, [])

    return (
        <MainContainer>
            <MainContent>
                <Box sx={{ my: 2, width: "100%", textAlign: "center" }}>
                    <img src={logo} width="300px" alt="logo" />
                </Box>

                <Typography variant="h6">Thank you for applying to New Eyes. We will send you an email with further
                instructions after we have reviewed your application.</Typography>
                <p />
                <a href="https://new-eyes.org/">Click here</a> to visit our home page.
            </MainContent>
        </MainContainer>
    )

}

export default ThankYouForApplying;